import { ErrorOutline, Info, Warning } from '@mui/icons-material';
import { Box, Dialog, DialogActions, Grid } from '@mui/material';
import { updatePortfolio } from 'lib/api/integrations/digitalSignature';
import InfoCard from 'lib/common/GeneralComponents/TenderModal/Components/InfoCard';
import SectionCard from 'lib/common/GeneralComponents/TenderModal/Components/SectionCard';
import AlertBanner from 'lib/designSystem/AlertBanner';
import CustomButton from 'lib/designSystem/Button';
import Title from 'lib/designSystem/Title';
import { showAlert } from 'lib/functions/utils';
import { Portfolio, PortfolioStatus } from 'lib/types/models';
import React from 'react';
import { useDispatch } from 'react-redux';

const InvalidateDialog = ({
  open,
  onClose,
  portfolio,
  onPortfolioUpdated,
}: {
  open: boolean;
  onClose: () => void;
  portfolio: Portfolio;
  onPortfolioUpdated?: () => void;
}) => {
  const dispatch = useDispatch();
  const { mutate, isPending } = updatePortfolio(dispatch);

  const handleInvalidatePortfolio = async () => {
    if (!portfolio?.id) {
      showAlert(dispatch, 'error', 'Portafolio no encontrado');
      return;
    }
    const body = {
      id: portfolio.id,
      status: 'INVALIDATED' as keyof typeof PortfolioStatus,
    };
    mutate(body, {
      onSuccess: () => {
        showAlert(dispatch, 'success', 'Portafolio invalidado exitosamente');
        onClose();
        onPortfolioUpdated?.();
        onClose();
      },
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        },
      }}
    >
      <Box sx={{ px: 2.5, pt: 2 }}>
        <Title
          title={'Invalidar Portafolio'}
          icon={<Warning color="warning" />}
          color="warning"
        />
      </Box>
      <Box sx={{ px: 2.5 }}>
        <SectionCard title="Información del Portafolio">
          <Grid container spacing={1.5}>
            <InfoCard
              icon={<Info />}
              label="Título"
              valueText={portfolio.title ?? 'Sin título'}
              color="primary.main"
            />
            <InfoCard
              icon={<ErrorOutline />}
              label="Estado Actual"
              valueText={portfolio.status}
              color="success.main"
            />
          </Grid>
        </SectionCard>
        <AlertBanner
          severity="warning"
          title="Advertencia"
          message="Esta acción invalidará el portafolio permanentemente. Si está asociado a un grupo de validación, causará que todo el grupo falle."
        />
      </Box>
      <DialogActions sx={{ p: 2.5, pt: 1 }}>
        <CustomButton color="secondary" onClick={onClose}>
          Cancelar
        </CustomButton>
        <CustomButton
          color="error"
          onClick={handleInvalidatePortfolio}
          loading={isPending}
          disabled={isPending}
        >
          Invalidar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default InvalidateDialog;
